import React, { useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../../layouts/MainLayout";
import "../../../assets/styles/custom-styles.css";
import useLoader from "../../../hooks/useLoader";
import useNotification from "../../../hooks/useNotification";
import { maskCep } from "../../../utils/maskUtils";
import DetailsSectionRenderer from "../../../components/DetailsSectionRenderer";
import { detailsAddressFields } from "../../../constants/forms/addressFields";
import useForm from "../../../hooks/useForm";
import { setDefaultFieldValues } from "../../../utils/objectUtils";
import useBaseService from "../../../hooks/services/useBaseService";
import { entities } from "../../../constants/entities";
import PageHeader from "../../../components/PageHeader";
import { useQuery } from "@tanstack/react-query";
import useQueryWithLoader from "../../../hooks/useQueryWithLoader";

const OrganizationAddressDetailsPage = () => {
  const navigate = useNavigate();
  const { organizationId, addressId } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const { showNotification } = useNotification();
  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate);
  const { formData, setFormData, formatData } = useForm(
    setDefaultFieldValues(detailsAddressFields),
  );

  const {
    data: addressData,
    isLoading: isLoadingAddress,
    isError: isErrorAddress,
    error: addressQueryError,
  } = useQueryWithLoader({
    queryKey: ["addressOrganization", organizationId, addressId],
    queryFn: async () => {
      const response = await baseServiceGetByColumn(
        entities.organizations.addresses.getById(organizationId, addressId),
      );
      return response.result;
    },
    enabled: !!organizationId && !!addressId,
  });

  useEffect(() => {
    if (!isLoadingAddress && addressData) {
      hideLoader();
      setFormData({
        alias: addressData.alias,
        zip: maskCep(addressData.zip),
        street: addressData.street,
        district: addressData.district,
        city: addressData.city,
        state: addressData.state,
        country: addressData.country,
        number: addressData.number,
      });
    }
    if (isErrorAddress && addressQueryError) {
      hideLoader();
      console.error("Erro ao buscar endereço:", addressQueryError);
      showNotification(
        "error",
        `Erro ao buscar endereço: ${addressQueryError?.message}`,
      );
      navigate(`/aluguel/organizacoes/detalhes/${organizationId}`);
    }
  }, [addressData, isLoadingAddress, isErrorAddress, addressQueryError]);

  const handleBack = useCallback(() => {
    navigate(`/aluguel/organizacoes/detalhes/${organizationId}`);
  }, [navigate, organizationId]);

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title="Detalhes do Endereço da Organização"
        showBackButton={true}
        backUrl={`/aluguel/organizacoes/detalhes/${organizationId}/`}
      />
      <div className="container-fluid p-1">
        <div
          className="p-3 mt-2 rounded shadow-sm mb-2"
          style={{ backgroundColor: "#FFFFFF" }}
        >
          <DetailsSectionRenderer
            sections={detailsAddressFields}
            formData={formData}
            handleBack={handleBack}
            readOnly={true}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default OrganizationAddressDetailsPage;
